import { render, staticRenderFns } from "./MarketplaceProfile.vue?vue&type=template&id=053e3086"
import script from "./MarketplaceProfile.vue?vue&type=script&lang=js"
export * from "./MarketplaceProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports